import React, { useEffect, useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Grid,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import nearByShops1 from "../../assets/images/Home_page_image/near_by_shops/near_by_shops1.png";
import nearByShops2 from "../../assets/images/Home_page_image/near_by_shops/near_by_shops2.png";
import nearByShops3 from "../../assets/images/Home_page_image/near_by_shops/near_by_shops3.png";
import nearByShops4 from "../../assets/images/Home_page_image/near_by_shops/near_by_shops4.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { useFetch } from "../../hooks";
import { buildShopPath } from "../../utils/functionalOperations";

const shopData = [
  {
    id: 1,
    name: "Japan Electronics",
    description: "Home Appliances are Available",
    distance: "4kms near to your Location",
    image: nearByShops1,
    rating: 4.8,
  },
  {
    id: 2,
    name: "Kalpana Mart",
    description: "Groceries, Milk and Food Products are Available",
    distance: "2kms near to your Location",
    image: nearByShops2,
    rating: 4.8,
  },
  {
    id: 3,
    name: "Pure Showroom",
    description: "Different Brand cars & Bikes are Available",
    distance: "3kms near to your Location",
    image: nearByShops3,
    rating: 4.8,
  },
  {
    id: 4,
    name: "UFO Stores",
    description: "Electronic Devices are Available",
    distance: "4kms near to your Location",
    image: nearByShops4,
    rating: 4.8,
  },
];

const ShopCard = ({ shop }) => {
  console.log("shop in ShopCard", shop);
  const navigate = useNavigate();
  const latitude = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null,
  );

  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const [vendors, setVendors] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);

  useEffect(() => {
    if (apptoken) {
      fetchData();
    }
  }, [apptoken, latitude, latitude]);

  const vendorUrl =
    latitude && longitude
      ? `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=20&vtype=regular`
      : null;

  const {
    data: vendorData,
    isLoading: isVendorsLoading,
    error,
    fetchData,
  } = useFetch(vendorUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });
  useEffect(() => {
    if (vendorData && vendorData.vendors) {
      const formattedVendors = vendorData.vendors.map((item) => {
        const firstCategory =
          Array.isArray(item.categories) && item.categories.length > 0
            ? item.categories[0]?.name
            : Array.isArray(item.listCategories) && item.listCategories.length > 0
              ? item.listCategories[0]?.name
              : "";

        return {
          id: item.id,
          name: item.name,
          shopName: item.shop_name,
          city: item.city || item.location || "unknown",
          location:
            item.location ||
            item.city ||
            item.street ||
            item.state ||
            "Location not available",
          categories: item.categories,
          listCategories: item.listCategories,
          category: firstCategory,
          description: firstCategory || "General",
          image: item.store_image,
          distance: item.distance
            ? `${item.distance} kms near to your Location`
            : "N/A",
          rating: "4.8" || "N/A",
          regularListType: item.reg_list_type,
        };
      });
      setVendors(formattedVendors);
    }
  }, [vendorData]);

  const handleShopNow = () => {
    navigate(buildShopPath(shop), { state: { shop } });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: { xs: 1, sm: 2, md: 4 },
      }}
    >
      {/* {vendors.map((shop) => ( */}
      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          padding: 2,
          width: "100%",
          maxWidth: { xs: "100%", md: 1280 },
          width: "100%",
          boxShadow: 3,
          borderRadius: 2,
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            padding: "4px 8px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <StarIcon sx={{ color: "#FFA500", fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ marginLeft: 0.5, color: "#FFA500" }}
          >
            {shop.rating}
          </Typography>
        </Box>
        <CardMedia
          component="img"
          sx={{
            width: { xs: "100%", sm: 300 },
            height: { xs: 180, sm: 220 },
            borderRadius: 2,
            objectFit: "cover",
          }}
          image={shop.image}
          alt={shop.name}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            marginLeft: { xs: 0, sm: 2 },
            marginTop: { xs: 2, sm: 0 },
          }}
        >
          <CardContent>
            <Typography variant="h6" component="div">
              {shop.shopName}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: "5px",
                marginBottom: 1,
                backgroundColor: "#FFF4E5",
                color: "#FF6F00",
              }}
            >
              {shop.category || shop.description}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                marginTop: 1,
              }}
            >
              <LocationOnIcon
                fontSize="small"
                sx={{ color: "#FF6F00", marginRight: 0.5 }}
              />
              {shop.location || shop.city || "Location not available"}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                marginTop: 1,
                color: "#666",
              }}
            >
              {shop.distance}
            </Typography>
          </CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              marginTop: "auto",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#FF6F00",
                color: "#fff",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#E65C00",
                },
                marginLeft: 3,
              }}
              size="small"
              onClick={handleShopNow}
            >
              Shop Now
            </Button>
          </Box>
        </Box>
      </Card>
      {/* ))} */}
    </Box>
  );
};

const NearbyShops = () => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const visibleShopsCount = 6;
  const [vendors, setVendors] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);
  const latitude = useSelector(
    (state) => state.user.userLocation?.latitude ?? null,
  );
  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );

  useEffect(() => {
    if (apptoken) {
      fetchData();
    }
  }, [apptoken, latitude, latitude]);

  const vendorUrl =
    latitude && longitude
      ? `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=20&vtype=regular`
      : null;

  const {
    data: vendorData,
    isLoading: isVendorsLoading,
    error,
    fetchData,
  } = useFetch(vendorUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (vendorData && vendorData.vendors) {
      const formattedVendors = vendorData.vendors.map((item) => {
        const firstCategory =
          Array.isArray(item.categories) && item.categories.length > 0
            ? item.categories[0]?.name
            : Array.isArray(item.listCategories) && item.listCategories.length > 0
              ? item.listCategories[0]?.name
              : "";

        return {
          id: item.id,
          name: item.name,
          shopName: item.shop_name,
          location:
            item.location ||
            item.city ||
            item.street ||
            item.state ||
            "Location not available",
          category: firstCategory,
          description: firstCategory || "General",
          image: item.store_image,
          distance: item.distance
            ? `${item.distance} kms near to your Location`
            : "N/A",
          rating: "4.8" || "N/A",
          address: `${item.street}, ${item.city}, ${item.state}, ${item.country}, ${item.pincode}`,
          openTime: item.open_time,
          closeTime: item.close_time,
          latitude: item.latitude,
          longitude: item.longitude,
          phoneNumber: item.phone_number,
          regularListType: item.reg_list_type,
        };
      });
      setVendors(formattedVendors);
    }
  }, [vendorData]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0
        ? Math.max(vendors.length - visibleShopsCount, 0)
        : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex >= vendors.length - visibleShopsCount ? 0 : prevIndex + 1,
    );
  };

  // const visibleShops = vendors.slice(
  //   currentIndex,
  //   currentIndex + visibleShopsCount
  // );
  const visibleShops = vendors.slice(currentIndex);
  console.log("visibleShops", visibleShops);
  return (
    <Box
      sx={{
        textAlign: "left",
        width: "100%",
        marginBottom: "50px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
          marginX: { xs: 2, sm: 5, md: 5 },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            marginBottom: "16px",
            color: "#333",
            marginLeft: { xs: 0, md: 15, lg: 1 },
            fontSize: {
              xs: "1rem",
              sm: "1.5rem",
              md: "1.75rem",
              lg: "1,75rem",
            },
          }}
        >
          Near By Shops
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Typography
            variant="body1"
            component={Link}
            to="/see-allnearbyShopsSection"
            sx={{
              textDecoration: "none",
              color: "#f57c00",
              fontWeight: "bold",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            See All
          </Typography>
          {/* <IconButton
            onClick={handlePrev}
            sx={{
              color: "#f57c00",
              border: "2px solid #f57c00",
              borderRadius: "10%",
              "&:hover": {
                backgroundColor: "#ffe4b3",
              },
              height: "30px",
              width: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ArrowBackIosIcon fontSize="medium" />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              color: "#f57c00",
              border: "2px solid #f57c00",
              borderRadius: "10%",
              "&:hover": {
                backgroundColor: "#ffe4b3",
              },
              height: "30px",
              width: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ArrowForwardIosIcon fontSize="medium" />
          </IconButton> */}
        </Box>
      </Box>
      {isVendorsLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : vendors.length === 0 ? (
        <Alert severity="info" sx={{ mt: 4, mx: 2 }}>
          <Typography
            variant="body1"
            sx={{ fontSize: "1.1rem", fontWeight: 500 }}
          >
            Please hold on, we are working on it. No shops found near your
            location.
          </Typography>
        </Alert>
      ) : (
        <Grid container spacing={2}>
          {visibleShops.map((shop) => (
            <Grid item xs={12} key={shop.id}>
              <ShopCard shop={shop} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default NearbyShops;
